import React from 'react';
import { WhatsButton } from './WhatsButton';

export const ShortFooter = () => (
  <footer className="px-6 sm:px-10 lg:px-16 pt-20 pb-28 lg:pb-12" data-testid="short-footer">
    <div className="max-w-3xl">
      <h2 className="sh-display text-6xl sm:text-8xl">Sua ideia,<br /><span className="text-[var(--sh-teal)]">nosso projeto.</span></h2>
      <p className="mt-6 text-base sm:text-lg text-[#F2F2EE]/70 max-w-md">Mande uma mensagem. Respondemos rápido e explicamos tudo sem complicação.</p>
      <div className="mt-10"><WhatsButton source="short-footer" testId="footer-whatsapp-cta" title="Chamar no WhatsApp" /></div>
    </div>
    <div className="mt-20 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between sh-mono text-[10px] sm:text-xs text-[#F2F2EE]/55">
      <span>Coutin Studio · Marketing · Audiovisual · Web</span>
      <a href="https://instagram.com/coutinagencia" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--sh-teal)] transition-colors" data-testid="footer-instagram-link">@coutinagencia</a>
      <span>Sua ideia, nosso projeto.</span>
    </div>
  </footer>
);
